import { useLocation } from "react-router-dom";

const Section4 = ({ data }) => {

    const location = useLocation()
    const firstPath = location.pathname.split("/")[2];
    return (
        <div className=" w-full flex justify-centers key-features">
            <div className="2xl:container mx-auto py-12 md:py-[72px] md:px-10 lg:px-20  px-6">
                <div className=" pb-6 sm:pb-12 md:pb-16 flex flex-col gap-6 items-center ">
                <h1 className="text-24  sm:text-32  lg:text-48 text-primarycolor text-center  font-semibold md:w-[80%] w-[90%]"> {data.Title}</h1>
                {firstPath == "xpertproof" && <p className="text-16 sm:text-18 text-center text-secondaryblack md:w-[80%] w-[90%]">{data.desc}</p>}
                </div>
                {firstPath !== "xpertproof" ?
                    <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-6 gap-4">
                        {data.Features.map((item, i) => {
                            const totalItems = data.Features.length;
                            const itemsPerRowMD = 2;
                            const itemsPerRowLG = 3;

                            const isLastRowMD = totalItems % itemsPerRowMD !== 0 && i >= totalItems - (totalItems % itemsPerRowMD);
                            const isLastRowLG = totalItems % itemsPerRowLG !== 0 && i >= totalItems - (totalItems % itemsPerRowLG);
                            let spanClass = "md:col-span-2 lg:col-span-2";
                            // Default span for full row
                            if (totalItems < 10) {

                                // If 2 items in last row
                                if (isLastRowMD && totalItems % itemsPerRowMD === 2) {
                                    spanClass = "md:col-span-2"; // 2 items evenly split at md
                                } else if (isLastRowMD && totalItems % itemsPerRowMD === 1) {
                                    spanClass = "md:col-span-4 lg:col-span-2"; // full span at md
                                }

                                if (isLastRowLG && totalItems % itemsPerRowLG === 2) {
                                    spanClass += " lg:col-span-3"; // half at lg
                                } else if (isLastRowLG && totalItems % itemsPerRowLG === 1) {
                                    spanClass += " lg:col-span-6"; // full span at lg
                                }
                            }
                            else {
                                const cycleIndex = [4, 5, 9, 10]

                                // Apply span classes based on the cycle index
                                if (cycleIndex.includes(i + 1)) {
                                    spanClass = "md:col-span-2 lg:col-span-3";  // 1st and 3rd items span 3 columns
                                } else {
                                    spanClass = "md:col-span-2 lg:col-span-2";  // 2nd and 4th items span 2 columns
                                }
                               

                            }
                            return (
                                <div
                                    key={i}
                                    className={`p-6 rounded-[16px] bg-white border-[1px] border-journyborder shadow-services flex flex-col gap-2 sm:gap-3 ${spanClass}`}
                                >
                                    <h4 className="font-semibold text-16 sm:text-18 text-primarycolor">
                                        {item.Title}
                                    </h4>
                                    <p className="text-14 font-regular sm:text-16 text-secondaryblack">
                                        {item.desc}
                                    </p>
                                </div>
                            );
                        })}
                    </div>
                    : <>
                        <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-8 gap-4">
                            {data.Features.map((item, i) => (
                                <div
                                    key={i}
                                    className={`p-6 rounded-[16px] bg-white border-[1px] border-journyborder shadow-services flex flex-col gap-2 sm:gap-3 col-span-1 md:col-span-2 lg:col-span-2`}
                                >
                                    <h4 className="font-semibold text-16 sm:text-18 text-primarycolor">
                                        {item.Title}
                                    </h4>
                                    <p className="text-14 font-regular sm:text-16 text-secondaryblack">
                                        {item.desc}
                                    </p>
                                </div>))}
                        </div>

                    </>}
            </div>
        </div>
    )
}

export default Section4;